/** @jsx h */
import Pagination from './Pagination';

const SearchList = ({ list, pagination, loadMore, pluginNamespace }) => {
  function handleLoadMoreClick() {
    loadMore();
  }
  return (
    <div class="search-list">
      <ul class="search-list__list">
        {list &&
          list.map(result => (
            <li class="search-list__item" key={`${result.type}-${result.id}`}>
              {result.areas &&
                result.areas.map(area => (
                  <div className="search-list__tag" key={area}>
                    <span>{area}</span>
                  </div>
                ))}

              {result.datetime ? (
                <div class="search-list__time">
                  <time class="search-list__time">{result.datetime}</time>
                </div>
              ) : (
                ''
              )}

              <h3 class="search-list__title">
                <a href={result.url} class="link">
                  {result.title}
                </a>
              </h3>
              <div class="search-list__text">
                <p>{result.teaser}</p>
              </div>
              {result.location ? (
                <div class="search-list__info">
                  <p>{result.location}</p>
                </div>
              ) : (
                ''
              )}
            </li>
          ))}
      </ul>
      <Pagination
        pagination={pagination}
        triggerLoadMore={handleLoadMoreClick}
        pluginNamespace={pluginNamespace}
      />
    </div>
  );
};

export default SearchList;
